import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback-stats-week',
  templateUrl: './feedback-stats-week.component.html',
  styleUrls: ['./feedback-stats-week.component.css']
})
export class FeedbackStatsWeekComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
